<script setup lang="ts">
    import SettingsPageLayout from '../components/settings/SettingsPageLayout.vue';
    import { __ } from '../stores/expressions';
    import EchoButton from '../components/EchoButton.vue';
    import UsersList from '../components/users/UsersList.vue';
    import { usePermissions } from '@/js/composables/usePermissions';
    import { PermissionArea, UserManagementPermissionFlag } from '@/js/consts/permissions';
    import { PlusIcon } from '@lucide/vue';

    const { hasPermission } = usePermissions();

    const canCreateUser = hasPermission(
        PermissionArea.UserManagement,
        UserManagementPermissionFlag.Access
    );
</script>

<template>
    <SettingsPageLayout fill-table>
        <template #header>
            <h1 class="heading-lg-light">{{ __('settings-manage-users') }}</h1>
            <p class="text-body">
                {{ __('manage-users-subtitle') }}
            </p>
        </template>
        <template #topbar>
            <EchoButton v-if="canCreateUser" variant="primary" route="/settings/manage-users/new">
                {{ __('manage-users-add-new-user') }}
                <template #icon-right><PlusIcon /></template>
            </EchoButton>
        </template>
        <template #content>
            <UsersList />
        </template>
    </SettingsPageLayout>
</template>
